<template id="Home">
	<div class="container">
			<span v-if="this.show_calcul" @click="hide" class="material-icons md-30 md-light close">close</span>
			<div v-if="this.show_calcul" v-clickoutside="hide">
				<Simulateur class="simulateur" id="Home_simulateur"></Simulateur>
			</div>
			<div v-if="!this.show_calcul" @click.prevent="show" class="patte blGradient blGradientHover">Calculer le prix de ma carte grise</div>
		<div class="hero">
	  		<div>
	  			<h1><span>Le spécialiste
	  			de l'immatriculation</span></br>
	  			<span class="annexe">et démarches annexes</span></br>
	  			<div class="separator"></div>
	  			<a href="#Gigean">à Gigean (34),</a><a href="#Sète">à Sète (34)</a></br>
	  			<strong>et en ligne !</strong></h1>
	  			<a href="https://lesrelaiscartegrise.setmore.com/" target="_blank"><button class="redGradient">Prendre rendez-vous</button></a>
	  		</div>
	  	</div>
	  	<div class="hero_resp">
	  		<div>
	  			<h1><span>Le spécialiste
	  			de l'immatriculation</span></br>
	  			<span class="annexe">et démarches annexes</span></br>
	  			<div class="separator"></div>
	  			à Gigean (34), à Sète (34)</br>
	  			<strong>et en ligne !</strong></h1>
	  			<div class="hero_btn"><a href="https://lesrelaiscartegrise.setmore.com/" target="_blank"><button class="redGradient">Prendre rendez-vous</button></a></div>
	  		</div>
	  	</div>
  		<div class="actions">
  			<router-link class="routerlink" to="/immatriculation/carte_grise">
  			<div class="action cartegrise">
  				<div class="title">
  					<h3>J'ai acquis un véhicule</h3>
  				</div>
  				<div class="sub">
  					<button>Je demande une carte grise</button>
  				</div>
  			</div>
  			</router-link>

  			 <router-link class="routerlink" to="/immatriculation/adresse">
  			<div class="action adresse">
  				<div class="title">
  					<h3>J'ai déménagé</h3>
  				</div>
  				<div class="sub">
  					<button>Je demande une étiquette</button>
  				</div>
  			</div>
  			</router-link>

  			 <router-link class="routerlink" to="/conduite">
  			<div class="action permis">
  				<div class="title">
  					<h3>Je demande un permis de conduire</h3>
  				</div>
  				<div class="sub">
  					<button>En savoir plus</button>
  				</div>
  			</div>
  			</router-link>

  			 <router-link class="routerlink" to="/conduite/codengo">
  			<div class="action codengo">
  				<div class="title">
  					<h3>Je passe l'examen du code Auto / Moto / Bateau</h3>
  				</div>
  				<div class="sub">
  					<button>Je m'informe et je m'inscris</button>
  				</div>
  			</div>
  			</router-link>
  		</div>
  		<div class="temp">
  			<div class="temp1">
  				<div class="subtempTxt">
  					<div>
	  					<h2>La qualité de service avant tout</h2>
			  			<p v-html="static.presentation"></p>
			  			<div class="reviews">
		  					<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-76 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-76 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-76 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-76 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-76 shadow">grade</span></a>
			  				<p><a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank">Voir les avis google</a></p>
	  					</div>
	  					<div class="reviews_resp">
		  					<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-48 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-48 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-48 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-48 shadow">grade</span></a>
			  				<a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank"><span class="material-icons md-yellow md-48 shadow">grade</span></a>
			  				<p><a href="https://www.google.com/search?q=carte+grise+gigean&oq=carte+grise+gigean&aqs=chrome.0.69i59l2j69i60l2j69i61j69i65.6433j0j1&sourceid=chrome&ie=UTF-8#lrd=0x12b14d85988bbf21:0x4b14832416f86fa6,1,,," target="_blank">Voir les avis google</a></p>
	  					</div>
  					</div>
  				</div>
  				<div class="subtempImg">
  					<div class="stars"></div>
  				</div>
  			</div>
	  		<div class="temp1">
	  			<div class="subtempTxt">
	  				<div>
		  				<h2>Découvrez nos Prestations</h2>
		  				<div class="services">
		  					<router-link class="service action" to="/immatriculation">
		  						<div>
			  						<h3>Immatriculation</h3>
			  						<p>Toutes démarches d'immatriculation des véhicules</p>
			  						<div class="service_immat service_img"></div>
			  					</div>
		  					</router-link>

							<router-link class="service action" to="/conduite">
			  					<div>
			  						<h3>Conduite</h3>
			  						<p>Demandes de permis de conduire et de numéro NEPH</p>
			  						<div class="service_conduite service_img"></div>
			  					</div>
							</router-link>

							<router-link class="service action" to="/conduite/stages">	
			  					<div>
			  						<h3>Stage de récupération de points</h3>
			  						<p>Inscription à des stages de récupération de points</p>
			  						<div class="service_stage service_img"></div>
			  					</div>
							</router-link>

							<router-link class="service action" to="/etat_civil">	
			  					<div>
			  						<h3>Etat-civil</h3>
			  						<p>Pré-demandes de passeports et cartes d'identité</p>
			  						<div class="service_civil service_img"></div>
			  					</div>
							</router-link>

							<router-link class="service action" to="/etat_civil/photomaton">	
		  					<div>
		  						<h3>Photomaton</h3>
		  						<p>Photomaton aggrée ANTS en agence</p>
		  						<div class="service_photo service_img"></div>
		  					</div>
		  					</router-link>

		  					<router-link class="service action" to="/conduite/codengo">	
			  					<div>
			  						<h3>Codengo</h3>
			  						<p>Examen du code de la Route (Auto Moto) et Bateau</p>
			  						<div class="service_codengo service_img"></div>
			  					</div>
							</router-link>

							<a class="service action" href="https://www.diamsauto.fr" target="_blank">	
		  					<div>
		  						<h3>Diam's Auto</h3>
		  						<p>Achat, vente, Dépot Vente de véhicules</p>
		  						<div class="service_diamsauto service_img"></div>
		  					</div>
							</a>

							<a class="service action" href="https://www.courtage.diamsauto.fr" target="_blank">	
			  					<div>
			  						<h3>Diam's Auto Courtage</h3>
			  						<p>Courtage d'assurances</p>
			  						<div class="service_assu service_img"></div>
			  					</div>
							</a>
		  				</div>
		  				<div class="services_btns">
		  					<router-link class="" to="/go">	
		  					<button class="blueGradient">Commencer une démarche en ligne</button>
		  					</router-link>
		  				</div>
	  				</div>
	  			</div>
	  		</div>
	  		<div class="temp1" id="Gigean">
	  			<div class="subtempImg agence2"></div>
		  			<div class="subtempTxt">
		  				<div>
			  				<h2>Notre Agence de Gigean (34770)</h2>
							<div class="home_infos">
								<div class="home_info">
									<span class="material-icons md-36 md-blue">location_on</span>
				  					<p v-html="static.adresse"></p>
								</div>
								<div class="home_info">
									<span class="material-icons md-36 md-blue">local_parking</span>
				  					<p>Parking privé à destination des clients</p>
								</div>
								<div class="home_info">
									<span class="material-icons md-36 md-blue">call</span>
				  					<p v-html="static.tel"></p>
								</div>
				  				<div class="home_info">
				  					<span class="material-icons md-36 md-blue">email</span>
				  					<p v-html="static.mail"></p>
				  				</div>
				  				<div class="home_info">
				  					<span class="material-icons md-36 md-blue">watch_later</span>
						      		<p v-html="static.horaires"></p>
				  				</div>
				  				<a href="https://lesrelaiscartegrise.setmore.com/gigean" target="_blank"><button class="redGradient">Prendre rendez-vous à Gigean</button></a>
							</div>
						</div>
		  			</div>
		  		</div>
		  		<div class="temp1" id="Gigean">
		  			<div class="subtempImg map">
			  			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2894.033755474666!2d3.7133469155295913!3d43.501631370236375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b14d85988bbf21%3A0x4b14832416f86fa6!2sService%20Carte%20Grise%20Gigean!5e0!3m2!1sfr!2sfr!4v1604836078868!5m2!1sfr!2sfr" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
			  		</div>
		  		</div>
		  		<div class="temp1" id="Sète">
		  			<div class="subtempTxt">
		  				<div>
			  				<h2>Notre Agence de Sète (34200)</h2>
							<div class="home_infos">
								<div class="home_info">
									<span class="material-icons md-36 md-blue">location_on</span>
				  					<p v-html="static.adresse_sete"></p>
								</div>
								<div class="home_info">
									<span class="material-icons md-36 md-blue">call</span>
				  					<p v-html="static.tel_sete"></p>
								</div>
				  				<div class="home_info">
				  					<span class="material-icons md-36 md-blue">email</span>
				  					<p v-html="static.mail_sete"></p>
				  				</div>
				  				<div class="home_info">
				  					<span class="material-icons md-36 md-blue">watch_later</span>
						      		<p v-html="static.horaires_sete"></p>
				  				</div>
				  				<a href="https://lesrelaiscartegrise.setmore.com/sete" target="_blank"><button class="redGradient">Prendre rendez-vous à Sète</button></a>
							</div>
						</div>
		  			</div>
		  			<div class="subtempImg agence_sete"></div>
			  	</div>
		  		<div class="temp1">
		  			<div class="subtempImg map">
			  			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7536.230741676492!2d3.7020504157844902!3d43.40929452993743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b1351b35104f35%3A0x7b08bf064e5f0381!2sLES%20RELAIS%20CARTE%20GRISE%20-%20S%C3%A8te%20%26%20Gigean!5e0!3m2!1sfr!2sfr!4v1666085320459!5m2!1sfr!2sfr" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
			  		</div>
		  		</div>
		  	</div>
  		</div>
  	</div>
</template>
<script>
	import Simulateur from './Simulateur.vue'
	const fb = require('../firebaseConfig.js')
	import firebase from 'firebase'
	export default {
	components:{Simulateur},
	name: 'Home',
	data () {
		return {
		show_calcul:false,
		info: null,
		static: {
      	horaires: '',
      	presentation: '',
      	tel: '',
      	mail: '',
      	adresse:"",
      	horaires_sete: '',
      	tel_sete: '',
      	mail_sete: '',
      	adresse_sete:""
			}

		}
	},
	methods: {
		hide(){
    		this.show_calcul = false
		},
    	show(){
     		this.show_calcul = true
     		// console.log(this.show_calcul)
    	}
	},
	mounted () {
		if(Object.keys(this.$store.state.static).length === 0){
			firebase.auth().signInAnonymously()
      			.then(() => {
				// console.log("object empty")
				fb.db.collection('documents').doc(this.$route.name).get()
		  		.then(res => {
			  		this.static.horaires = res.data().horaires
			  		this.static.presentation = res.data().presentation
			  		this.static.tel = res.data().tel
			  		this.static.mail = res.data().mail
			  		this.static.adresse = res.data().adresse
			  		this.static.tel_sete = res.data().tel_sete
			  		this.static.mail_sete = res.data().mail_sete
			  		this.static.adresse_sete = res.data().adresse_sete
			  		this.static.horaires_sete = res.data().horaires_sete
		  		})
		  	})
		}else{
			// console.log("object not very empty my friend")
			var doc = this.$store.state.static[this.$route.name]
	  		this.static.horaires = doc.horaires
	  		this.static.presentation = doc.presentation
	  		this.static.tel = doc.tel
	  		this.static.mail = doc.mail
	  		this.static.adresse = doc.adresse
	  		this.static.tel_sete = doc.tel_sete
		  	this.static.mail_sete = doc.mail_sete
		  	this.static.adresse_sete = doc.adresse_sete
		  	this.static.horaires_sete = doc.horaires_sete
		}
	}
}
</script>
<style scoped>

	.container{
		background-image:linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4)),url(../assets/agence2.jpg);
	    background-position: 0% 50%;
	    background-repeat: no-repeat;
	    background-size: cover;
	    background-attachment:fixed;
	}
	.hero_resp, .reviews_resp{
		display: none;
	}
	.reviews_resp p, .reviews p{
		font-style: italic;
	}
	.hero{
		position:relative;
		padding:90px 20px 250px 20px;
		width:60%;
		left:15%;
		top:80px;
	}
	.simulateur{
		margin-top:20px;
/*		display:flex;
		align-items:center;*/
	}
	.hero h1{
		/*text-align: center;*/
		color:#ffffff;
	  	text-shadow: 0px 1px 1px white;
	  	font-family: 'Merriweather', serif;
	  	//font-size:36px;
	}
	.hero span{
		font-family: 'Roboto', sans-serif;
	  	font-size:2.2em;
	  	line-height:80px;
	}
	.hero span.annexe{
		/*font-family: inherit;*/
	  	font-size:inherit;
	  	line-height:inherit;
	}
	.hero .separator{
		height:50px;
	}
	.hero button{
		margin-top: 50px;
		font-size:20px;
/*		background: rgb(255,0,72);
		background: linear-gradient(169deg, rgba(255,0,72,1) 0%, rgba(204,11,66,1) 100%);*/
	}
	.hero button:hover{
	}

	.stars{
		background-image:url(../assets/undraw_positive_attitude_re_wu7d.svg);
		background-size:contain;
		background-repeat: no-repeat;
		background-position: center;
	}

	.agence2{
		background-image:url(../assets/agence_gigean.png);
		background-position:center;
		background-size:contain;
		background-repeat:no-repeat;
	}
	.agence_sete{
		background-image:url(../assets/agence_sete.png);
		background-position:center;
		background-size:contain;
		background-repeat:no-repeat;
	}
	.services{
		display: flex;
		flex-flow: row wrap;
		margin: inherit;
		padding: 5px;
		justify-content: center;

	}
	.service{
		/*width:25%;*/
		flex:0 0 20.05%;
		padding: 15px;
		margin: 15px;
		height: inherit;
		background: white;
		box-shadow: 1px 1px 1px #1a1a1a;
	}
	.service:hover{
		transform: scale(1.02);
		box-shadow: 3px 3px 4px #1a1a1a;
	}

	.service h3, .service p{
		min-height: 70px;
		justify-content: center;
		align-items: center;
		display: flex;
		margin:5px;
	}
	/*.service h3{
		font-size:1em;
	}
	.service p{
		font-size:0.95em;
	}*/
	.service_img{
		background-size:contain;
		background-repeat: no-repeat;
		background-position: center;
		height:80px;
		margin-bottom: 5px;
	}
	.service_immat{
		background-image:url(../assets/car2.svg);/*#22417B*/
	}
	.service_conduite{
		background-image:url(../assets/permis.svg);/*#22417B*/
	}
	.service_stage{
		background-image: url(../assets/stages4.png);
	}
	.service_civil{
		background-image: url(../assets/etat_civil.svg);
	}
	.service_photo{
		background-image: url(../assets/logo_photomaton.png);
	}
	.service_codengo{
		background-image: url(../assets/codengo3.png);
	}
	.service_diamsauto{
		background-image: url(../assets/diamsauto.png);
	}
	.service_assu{
		background-image: url(../assets/diamsauto_courtage.png);
	}
	.prestations{
		background-image:url(../assets/prestations.svg);/*#22417B*/
		background-size:contain;
		background-repeat: no-repeat;
		background-position: center;
	}
	.patte{
	color:white;
	text-align:center;
	font-size:1em;
	padding-top:15px;
	//display:inline-block;
	margin:0 auto;
	width:300px;
	padding:50px 60px 20px 60px;
	border-radius:0px 0px 30px 30px;
	cursor:pointer;
	user-select: none;
	//position:absolute;
	font-weight:500;
/*	-webkit-transition: all .2s ease-out;
	-moz-transition: all .2s ease-out;
	-o-transition: all .2s ease-out;
	transition: all .2s ease-out;*/
	animation: move 3s infinite forwards;
}
@keyframes move{
  0% { transform: translateY(0px);}
  12.5% { transform: translateY(0px);}
  25% { transform: translateY(0px);}
  37.5% { transform: translateY(0px);}
  50% { transform: translateY(0px);}
  62.5% { transform: translateY(0px);}
  75% { transform: translateY(10px);}
  /*87.5%{ transform: translateY(0px);}*/
  100% { transform: translateY(0px);}
}

.patte:hover{
/*	animation:none;
	transform:scale(1.1);*/
}
.close{
	position:absolute;
	right:10px;
	cursor:pointer;
	z-index:888;
	top:150px
}
.contain_simu{
	padding-top:50px;
	width: 100%;
	display: flex;
	justify-content:center;
	align-items: center;
}

/*	.about{
		background-color:#22407a;
		padding:50px 25px 25px 25px;
	}
	.presentation h3{
		color:white;
		padding-bottom:25px;

	}

	.presentation{
		//padding :25px;
		text-align:center;
		font-size:1em;
		//line-height:2px;
		width:80%;
		margin:auto;
	}

	.home_infos{
		display:flex;
		justify-content:center;
		flex-wrap:wrap;
	}
	.horaires, .contact{
		display:flex;
		flex-direction:column;
		text-align:center;
		justify-content:center;
		border-radius:5px;
		box-shadow: 0px 2px 2px #1a1a1a;
		width:300px;
		height:240px;
		margin:30px;
		padding:5px;
	}

	.horaires p, .contact p{
		color:#ffffff;
		margin:0px;
		text-shadow: 1px 1px 2px #ffffff;
		text-shadow: 0px 1px 1px #ffffff;
	}

	.contact{
		background:linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4)),url(../assets/contact.jpg);
		background-size:cover;
	}

	.horaires{
		background:linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4)),url(../assets/devanture.jpg);
		background-size:cover;
		background-position:center;
	}

	.presentation p{
		color:#ffffff;
		text-shadow: 1px 1px 2px #ffffff;
		text-shadow: 0px 1px 1px #ffffff;
	}*/

	.subtempImg.map{
		min-height: 400px;
	}

	@media all and (max-width: 800px) {
		.actions{display: none}
		.hero_resp{display:flex;padding:100px 20px 100px 20px;text-align: center;font-size:0.7em;justify-content:center;}
		.reviews_resp{display: inline;}
		.hero_resp h1{width:100%;}
		.horaires, .contact{margin:25px 0px 25px 0px;}

		.patte{width: 150px;}

		.hero, .reviews{
			display: none;
		}

		.hero_resp h1{
		/*text-align: center;*/
		color:#ffffff;
	  	text-shadow: 0px 1px 1px white;
	  	font-family: 'Merriweather', serif;
		}
		.hero_resp span{
			font-family: 'Roboto', sans-serif;
		  	font-size:1.4em;
		  	line-height:50px;
		}
		.hero_resp span.annexe{
			/*font-family: inherit;*/
		  	font-size:inherit;
		  	line-height:inherit;
		}
		.hero_resp .separator{
			height:40px;
		}
		.hero_resp button{
			margin-top: 40px;
			font-size:20px;
		}

	}

	@media all and (max-width: 1200px) {
		.hero h1, .presentation{width:90%;}
		.home_info{margin-top: 5px;}

		.temp1{flex-flow:column;}
		.subtempTxt{order:2;min-height:250px;padding-bottom: 20px;min-width:inherit;}
		.subtempTxt div{padding:inherit;/*width:inherit*/;margin:6px 0px 6px 0px}
		.subtempTxt div > p{padding:0px 30px 0px 30px;}
		.subtempImg{order: 1;min-height:250px;min-width:inherit;padding: 10px 0px 10px 0px}
		.subtempImg.map{margin-bottom:70px;min-height:100%;}
		.subtempImg div{width:40%;}

		.service{margin:15px 5px 15px 5px}
		.service h3, .service p{
			margin:0px;
		}
		.service > div{
			padding: 5px 0px 5px 0px;
			margin: 5px 0px 5px 0px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue